import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { STORE_NAMES } from './constants';

export interface DTCAudienceTask {
  taskId: string;
  eventId?: string;
  workspaceId: number;
  type: 'request' | 'publish';
}

interface DTCAudienceTasksState {
  activeTasks: DTCAudienceTask[];
  addTask: (task: DTCAudienceTask) => void;
  removeTask: (taskId: string) => void;
}

export const useDTCAudienceTasksStore = create<DTCAudienceTasksState>()(
  devtools(
    persist(
      (set, get) => ({
        activeTasks: [],
        addTask: (task) => {
          const existing = get().activeTasks.find((t) => t.taskId === task.taskId);
          if (!existing && task.taskId) {
            set({ activeTasks: [...get().activeTasks, task] }, undefined, 'dtcAudienceTasks/addTask');
          }
        },
        removeTask: (taskId) => {
          set(
            { activeTasks: get().activeTasks.filter((t) => t.taskId !== taskId) },
            undefined,
            'dtcAudienceTasks/removeTask',
          );
        },
      }),
      { name: STORE_NAMES.DTC_AUDIENCE_TASKS },
    ),
    { name: STORE_NAMES.DTC_AUDIENCE_TASKS, enabled: process.env.NODE_ENV === 'development' },
  ),
);
